"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const react_1 = __importDefault(require("react"));
const lodash_1 = __importDefault(require("lodash"));
const design_system_1 = require("@zapier/design-system");
const PathDropdownItems_1 = __importDefault(require("./PathDropdownItems"));
const getBreadcrumbMenu_1 = __importDefault(require("./getBreadcrumbMenu"));
const navSectionStyle = core_1.css `
  align-items: center;
  display: flex;
  height: 40px;
  border-bottom: 1px solid ${design_system_1.Colors.grey200};
  cursor: pointer;
  padding: 0 10px;
  &:hover {
    background-color: ${design_system_1.Colors.grey100};
  }
`;
const navSectionIconStyle = core_1.css `
  fill: ${design_system_1.Colors.grey500};
  margin-right: 10px;
`;
const BackSection = (props) => {
    return (core_1.jsx("div", { "aria-label": "Go back", css: navSectionStyle, onClick: props.onClick, onKeyDown: () => { }, role: "link", tabIndex: 0 },
        core_1.jsx(design_system_1.Icon, { css: navSectionIconStyle, name: "arrowSmallRight", size: 24 }),
        "Back"));
};
const HomeSection = (props) => {
    return (core_1.jsx("div", { "aria-label": "Home", css: navSectionStyle, onClick: props.onClick, onKeyDown: () => { }, role: "link", tabIndex: 0 },
        core_1.jsx(design_system_1.Icon, { css: navSectionIconStyle, name: "navHome", size: 24 }),
        "Home"));
};
class PathDropdownMenu extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            breadcrumbRootNodeStack: [],
        };
        this.onDescendGeneration = (newRootId) => {
            this.setState(state => ({
                breadcrumbRootNodeStack: state.breadcrumbRootNodeStack.concat(newRootId),
            }));
        };
        this.onAscendGeneration = () => {
            const { breadcrumbRootNodeStack } = this.state;
            this.setState({
                breadcrumbRootNodeStack: lodash_1.default.dropRight(breadcrumbRootNodeStack, 1),
            });
        };
    }
    render() {
        const { pathNodes, onToggleMenu, onSelectPath, routeToRootPathGroup, flowNodes, breadcrumbMenuFn = getBreadcrumbMenu_1.default, currentNode, } = this.props;
        const { breadcrumbRootNodeStack } = this.state;
        const shouldSliceTree = !lodash_1.default.isEmpty(breadcrumbRootNodeStack);
        const treeNodeStartId = shouldSliceTree
            ? Number(lodash_1.default.last(breadcrumbRootNodeStack))
            : null;
        const pathNodesStartIndex = shouldSliceTree
            ? lodash_1.default.findIndex(pathNodes, node => node.id === treeNodeStartId)
            : 0;
        const BackOrHomeSection = lodash_1.default.isEmpty(breadcrumbRootNodeStack)
            ? HomeSection
            : BackSection;
        return [
            core_1.jsx(BackOrHomeSection, { key: "back", onClick: lodash_1.default.isEmpty(breadcrumbRootNodeStack)
                    ? () => {
                        onToggleMenu();
                        routeToRootPathGroup();
                    }
                    : this.onAscendGeneration }),
            core_1.jsx(PathDropdownItems_1.default, { currentNode: currentNode, flowNodes: flowNodes, generation: 0, key: "path dropdown items", onDescendGeneration: this.onDescendGeneration, onSelectPath: onSelectPath, onToggleMenu: onToggleMenu, pathNodes: breadcrumbMenuFn(pathNodes.slice(pathNodesStartIndex), flowNodes), shouldShowSiblingTreeLine: false }),
        ];
    }
}
exports.default = PathDropdownMenu;
